var loading = false;

var nextElementHref = undefined;

function onPageLoad() {
  if (this.status === 404) {
    return;
  }

  var feedElement = $(".post-feed")[0];
  if (!feedElement) {
    return;
  }

  var postElements = this.response.querySelectorAll("article.post-card.simple");
  postElements.forEach(function (item) {
    feedElement.appendChild(document.importNode(item, true));
  });

  var resNextElement = this.response.querySelector("link[rel=next]");
  nextElementHref = resNextElement ? resNextElement?.href : undefined;

  loading = false;
}

function onClick(href) {
  if (!href) {
    return;
  }

  if (loading) {
    return;
  }

  loading = true;

  var xhr = new window.XMLHttpRequest();
  xhr.responseType = "document";

  xhr.addEventListener("load", onPageLoad);

  xhr.open("GET", href);
  xhr.send(null);
}

$(document).ready(function () {
  var nextElement = $("link[rel=next]")[0];
  nextElementHref = nextElement ? nextElement.href : undefined;

  $("#load_more").on("click", function () {
    onClick(nextElementHref);
  });
});
